import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import React from 'react';
import DateTimePicker from 'react-datetime-picker';
import { isSome, renderIf, translate } from 'core/utils';
import { defaultTemplate } from 'core/hoc';

const DatePickerTemplate = ({ field, title, minDate, maxDate, onChange, errorMessage }) => {
	return (
		<div className="inputgroup pos--rel">
			<div>
				<label htmlFor={field.id}>
					{title ? translate(field.label, { title: title }) : translate(field.label)}{' '}
					{field.rules && field.rules.indexOf('required') !== -1 ? (
						<span className="type--color--warning">*</span>
					) : null}
				</label>
			</div>

			{/* Error message */}
			{renderIf(isSome(errorMessage))(
				<p className="type--tny type--color--error spc--bottom--tny">{translate(errorMessage)}</p>
			)}

			{/* Form field error */}
			{renderIf(isSome(field.error))(
				<p className="type--tny type--color--error spc--bottom--tny">{translate(field.error)}</p>
			)}

			<section className="pos--rel">
				<DateTimePicker
					value={field.value}
					onChange={onChange}
					disableClock={true}
					dayPlaceholder="DD"
					monthPlaceholder="MM"
					yearPlaceholder="YYYY"
					calendarIcon={null}
					minDate={minDate}
					maxDate={maxDate ? maxDate : new Date(9999, 11, 31)}
				/>
			</section>
		</div>
	);
};

export default defaultTemplate(DatePickerTemplate);
